// extracted by mini-css-extract-plugin
export const root = "profile-module--root--Y5Ibe";
export const paper = "profile-module--paper--Jvz8P";
export const container = "profile-module--container--hcwSO";
export const stat = "profile-module--stat--uo6Vf";
export const content = "profile-module--content--ZmShP";
export const error = "profile-module--error--XkbJi";
export const table = "profile-module--table--Towo7";
export const oldWithdrawal = "profile-module--oldWithdrawal--qbZuR";
export const newWithdrawal = "profile-module--newWithdrawal--dvDX2";